export const SankeyOrientation = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const SankeyNodeAlign = {
  LEFT: 'left',
  RIGHT: 'right',
  JUSTIFY: 'justify',
  CENTER: 'center',
};

export const SankeyLinkFillStyle = {
  GRADIENT: 'gradient',
  SOLID: 'solid',
  SOURCE: 'source',
  TARGET: 'target',
};

export const SankeyDataField = {
  FROM: 'from',
  TO: 'to',
  VALUE: 'value',
};

export const SankeyTooltipText = {
  LINK_PREFIX: '{sourceId} → {targetId}\n',
};

export const SankeyMaxNodes = {
  DEFAULT: 30,
  MIN: 10,
  MAX: 50,
};

export const OUTGOING_LINKS = 'outgoingLinks';
export const LABEL = 'label';
